// extracted by mini-css-extract-plugin
export var box = "Title-module--box--c98be";
export var box_md = "Title-module--box_md--96e53";
export var box_xmd = "Title-module--box_xmd--3192b";
export var box_flex = "Title-module--box_flex--82050";
export var box_lg = "Title-module--box_lg--c924b";
export var box_sm = "Title-module--box_sm--7b3a9";
export var box_outer = "Title-module--box_outer--47dbd";
export var box_whiteBg = "Title-module--box_white-bg--afeba";
export var box_noMarginBottom = "Title-module--box_no-margin-bottom--37316";
export var box_noPadding = "Title-module--box_no-padding--80074";
export var box_outerGray = "Title-module--box_outer-gray--84629";
export var box_dark = "Title-module--box_dark--40dc7";
export var box_zIndex = "Title-module--box_z-index--ecac6";
export var box_zIndex6 = "Title-module--box_z-index-6--43f8b";
export var box_eventsWithLine = "Title-module--box_events-with-line--1c8b1";
export var box_featuresAo = "Title-module--box_features-ao--247e6";
export var box_verticalPaddings = "Title-module--box_vertical-paddings--060f1";
export var clearP = "Title-module--clearP--166b0";
export var clearP_vc = "Title-module--clearP_vc--0031b";
export var title = "Title-module--title--18829";
export var h1 = "Title-module--h1--7d906";
export var h2 = "Title-module--h2--940c1";
export var h3 = "Title-module--h3--2d9fa";
export var h4 = "Title-module--h4--a2c04";
export var h5 = "Title-module--h5--04171";
export var black = "Title-module--black--16e98";
export var white = "Title-module--white--87dc2";
export var fadeInAnimation = "Title-module--fadeInAnimation--2d8fd";
export var placeHolderShimmer = "Title-module--placeHolderShimmer--b0d42";